import templateUrl from '../resource-subcategory-add-edit.html';

export const resourcesSubcategoryMainComponent = {
    templateUrl,
    bindings: {
        details: '<',
        onSubmit: '&',
        onCancel: '&',
        title: '@',
        disableButtons: '<',
        subCategoryList: '<'

    },
    controller: class resourcesSubcategoryMainComponent {
        constructor($cookies, $state, CompareObjectService, Constants, toastr, ApiService, FileUploadService, resourcesService, $stateParams, $anchorScroll) {
            'ngInject';

            this.$cookies = $cookies;
            this.$state = $state;
            this.compareObjectService = CompareObjectService;
            this.constants = Constants;
            this.resourcesService = resourcesService;
            this.$stateParams = $stateParams;
            this.$anchorScroll = $anchorScroll;
            this.fileUploadService = FileUploadService;
            this.apiService = ApiService;
            this._toastr = toastr;
        }

        $onInit() {
            this.categoryNameError = false;
            this.linkError = false;
            this.fileError = false;
            this.pdfError = false;

            this.categoryDetailsOption = this.resourcesService.getCategoryOption();
            this.radioCategotyDefaultOption = this.constants.RESOURCE.CATEGORY_OPTION.WEB_LINK;

            this.details = this.details || {
                name: '',
                resourceId: '',
                resourceName: this.resourceName,
                link: ""
            }
            this.saveData = angular.copy(this.details);
        }

        _onSubmit() {
            this.categoryNameError = false;
            this.linkError = false;

            if (!this.details.name) {
                this.categoryNameError = true;
            } else {
                if (this.details.name && this.details.name.trim() === "") {
                    this.categoryNameError = true;
                }
            }

            if (!this.details.link) {
                this.linkError = true
            }


            if (this.categoryNameError === false && this.linkError === false && this.pdfError === false) {
                this.onSubmit({
                    details: this.details
                });
            }

        }

        onsubmitSubcategory(event) {
            this.details.subCategoryList = event.details;
            this._onSubmit();
        }

        _onCancel(event) {
            this.details.subCategoryList = event.details;
            const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, this.details, false);
            this.onCancel({
                isUpdated: isUpdated
            });
        }

        onChangeCategoryOption({ id }) {
            this.details.option = parseInt(id);
        }

        onFileChange(file) {
            this.details.file = file;
            if (file) {
                this.imageName = file.name;
                this.disableButtons = true;
                this.details.fileType = file.type;
                this.fileUploadService.uploadFile(file, "resource")
                    .then(({ data: { data: { uuid } } }) => {
                        if (this._ifFileTypeIsImage(this.details.fileType)) {
                            this.details.image = uuid;
                            this.details.pdf = null;
                            this.details.imageUrl = this.apiService.getResourceUrl(`v1/file/${this.details.image}?jwt=${this.$cookies.get('token')}`);
                        } else if (this._ifFileTypeIsPdf(this.details.fileType)) {
                            this.details.imageUrl = "";
                            this.details.pdf = uuid
                            this.details.image = null;
                        }
                        this.disableButtons = false;
                    })
                    .catch(err => {
                        this.disableButtons = false;
                        this._toastr.error(err);
                    });
            } else {
                this.details.file = {};
                this.details.file.name = this.imageName;
                this.disableButtons = false;
            }
            this.fileError = false;
        }

        otherResourceSubmit() {
            this._onSubmit();
        }

        otherResourceCancel() {
            const compObject = angular.copy(this.details);
            const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, this.details, false);
            this.onCancel({
                isUpdated: isUpdated
            });
        }

        _ifRadioButtonOptionIsLink(selectRadioButtonOption, webLinkRadioButtonOption) {
            return selectRadioButtonOption === webLinkRadioButtonOption;
        }

        _ifFileTypeIsImage(fileType) {
            return fileType === 'image/jpeg' || fileType === 'image/png';
        }

        _ifFileTypeIsPdf(fileType) {
            return fileType === 'application/pdf';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/resources/resource-subcategory-main/resource-subcategory-main.component.js